import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, onManageDisableScrolling, soldByName, soldByLinkProps } = props;
  const images = listing.images;
  const imageVariants = [
    'scaled-small',
    'scaled-medium',
    'scaled-large',
    'scaled-1600',
    'scaled-xlarge',
  ];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  if (!listing?.id) {
    return null;
  }

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        onManageDisableScrolling={onManageDisableScrolling}
        soldByName={soldByName}
        soldByLinkProps={soldByLinkProps}
      />
    </section>
  );
};

export default SectionGallery;
